import { createGlobalStyle } from 'styled-components';

export const colors = {
  navyBlue: '#133B5C',
  forestGreen: '#2A7131',
  offWhite: '#F9F6F1',
  warmGray: '#999589', // Optional accent
  white: '#FFFFFF',
};

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@700&display=swap');

  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Oswald', 'Arial Black', 'Impact', sans-serif; /* Oswald Bold, with fallbacks */
    background-color: ${colors.offWhite};
    color: ${colors.navyBlue}; /* Default text color */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700; /* Bold Oswald */
    text-transform: uppercase; /* All caps for headers */
    color: ${colors.navyBlue};
  }

  /* Add other global resets or base styles if needed */
`; 